export const dependencies = [
        {
            name: "DashboardElement",
            type: "static",
            fields: [
                {path: "id", type: "string"},
                "name",
                "type",
                "url",
                "suffix",
                "link",
                "keys",
                "colors",
                "width",
                "sum",
                "sumColor",
                "absolute"
            ],
            objects: [
                {
                    id: "000000000000000000000001",
                    name: "balanceByUser",
                    width: 12,
                    type: 'multipleBarChart',
                    url: "BalanceByUser",
                    keys: ['paidRefund', 'postedRefund', 'refundBalance', 'refundLimit'],
                    colors: ['#15a021', '#1b638e', '#bbb', '#656565']
                },
                {
                    id: "000000000000000000000002",
                    name: "animatedVideo",
                    width: 12,
                    type: 'video',
                    url: "AnimatedVideo",
                },
                {
                    id: "000000000000000000000003",
                    name: "holidaysVideo",
                    width: 6,
                    type: 'video',
                    url: "HolidaysVideo",
                },
                {
                    id: "000000000000000000000004",
                    name: "burnoutVideo",
                    width: 12,
                    type: 'video',
                    url: "BurnoutVideo",
                },
                {
                    id: "000000000000000000000005",
                    name: "newYearVideo",
                    width: 6,
                    type: 'video',
                    url: "NewYearVideo",
                },
                {
                    id: "000000000000000000000006",
                    name: "votingVideo",
                    width: 12,
                    type: 'video',
                    url: "VotingVideo",
                }
            ]
        }
    ]

export const entity = {
    name: "DashboardAffectation",
    fields: [
        {type: "User"},
        {
            path: "elements",
            type: "DashboardElement",
            link: {
                type: "OTM",
                onParent: true,
                onChild: false
            },
            notEmpty: true
        },
    ]
}

export const module_ = {
    object: "DashboardAffectation",
    tKey: "dashboard",
    noLeftBoard: true,
    displayLog: false,
    category: {
        path: 'referential',
        icon: 'server'
    },
    viewMap: {
        dt: [
            "user"
        ],
        form: [
            "user",
            {path: "elements", type: "tags", display:"name"}
        ]
    }
}
